/* NotFoundView.tsx generated by @compiled/babel-plugin v0.36.1 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["testId"];
import "./NotFoundView.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { useMemo } from 'react';
import { useIntl } from 'react-intl-next';
import LockLockedIcon from '@atlaskit/icon/core/lock-locked';
import LegacyLockIcon from '@atlaskit/icon/glyph/lock';
import { extractProvider } from '@atlaskit/link-extractors';
import { fg } from '@atlaskit/platform-feature-flags';
import { R300 } from '@atlaskit/theme/colors';
import { messages } from '../../../messages';
import Text from '../../FlexibleCard/components/elements/text';
import { NotFoundViewOld } from './NotFoundViewOld';
import UnresolvedView from './unresolved-view';
import { withFlexibleUIBlockCardStyle } from './utils/withFlexibleUIBlockCardStyle';
var textStyles = null;

/**
 * This view represents a Block Card with a 'Not_Found' status.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */
var NotFoundViewNew = function NotFoundViewNew(_ref) {
  var _cardState$details2;
  var _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? 'smart-block-not-found-view' : _ref$testId,
    props = _objectWithoutProperties(_ref, _excluded);
  var intl = useIntl();
  var cardState = props.cardState;
  var product = useMemo(function () {
    var _cardState$details, _provider$text;
    var provider = extractProvider(cardState === null || cardState === void 0 || (_cardState$details = cardState.details) === null || _cardState$details === void 0 ? void 0 : _cardState$details.data);
    return (_provider$text = provider === null || provider === void 0 ? void 0 : provider.text) !== null && _provider$text !== void 0 ? _provider$text : '';
  }, [cardState === null || cardState === void 0 || (_cardState$details2 = cardState.details) === null || _cardState$details2 === void 0 ? void 0 : _cardState$details2.data]);
  var title = useMemo(function () {
    return intl.formatMessage(messages.not_found_title, {
      product: product
    });
  }, [intl, product]);
  var description = useMemo(function () {
    return {
      descriptor: messages.not_found_description
    };
  }, []);
  return /*#__PURE__*/React.createElement(UnresolvedView, _extends({}, props, {
    testId: testId,
    title: title
  }), fg('platform-smart-card-icon-migration') ? /*#__PURE__*/React.createElement(LockLockedIcon, {
    label: "not-found-lock-icon",
    color: "var(--ds-icon-danger, #C9372C)",
    LEGACY_fallbackIcon: LegacyLockIcon,
    LEGACY_size: "small",
    testId: "".concat(testId, "-lock-icon")
  }) :
  /*#__PURE__*/
  // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19497
  React.createElement(LegacyLockIcon, {
    label: "not-found-lock-icon",
    size: "small",
    primaryColor: "var(--ds-icon-danger, ".concat(R300, ")"),
    testId: "".concat(testId, "-lock-icon")
  }), /*#__PURE__*/React.createElement(Text, {
    message: description,
    testId: "".concat(testId, "-message"),
    maxLines: 3,
    className: ax([fg('platform-linking-visual-refresh-v1') && "_syaz1fxt"])
  }));
};
var NotFoundView = function NotFoundView(props) {
  if (fg('bandicoots-compiled-migration-smartcard')) {
    return /*#__PURE__*/React.createElement(NotFoundViewNew, props);
  } else {
    return /*#__PURE__*/React.createElement(NotFoundViewOld, props);
  }
};
export default withFlexibleUIBlockCardStyle(NotFoundView);